import api from './api'

const organization = {}

organization.addUsers = (id, payload) => api.put(`/organizations/${id}/add-users`, payload)

organization.updateUser = (id, payload) => api.put(`/organizations/${id}/update-user`, payload)

organization.unlinkUser = (id, payload) => api.put(`/organizations/${id}/unlink-user`, payload)

organization.createOrganization = (id, payload) =>
  api.put(`/organizations/${id}/create-organization`, payload)

organization.updateOrganization = (id, payload) =>
  api.put(`/organizations/${id}/update-organization`, payload)

organization.deleteOrganization = (id, payload) =>
  api.put(`/organizations/${id}/remove-organization`, payload)

organization.updateMinutes = (id, payload) =>
  api.put(`/organizations/${id}/update-minutes`, payload)

export default organization
